var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"table"},[_c('div',{staticClass:"header"},[_vm._t("header"),_c('div',{staticClass:"background"})],2),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }